import { Ref } from 'react';
import { StanSegmentProps } from '../StanSegmentedControl.types';
import { createIconElement } from '@/lib';
import { cn } from '@/lib/utils/cn';
import styles from './StanSegment.module.css';

interface StanSegmentPropsWithRef extends StanSegmentProps {
    ref?: Ref<HTMLButtonElement>;
}

export const StanSegment = ({
    option,
    isSelected,
    isDisabled,
    size,
    variant,
    onClick,
    onKeyDown,
    ref,
}: StanSegmentPropsWithRef) => {
    const { value, label, icon, disabled = false } = option;
    const isActuallyDisabled = isDisabled || disabled;

    const handleClick = () => {
        if (!isActuallyDisabled) {
            onClick();
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (!isActuallyDisabled) {
            onKeyDown(event);
        }
    };

    const segmentClasses = cn(styles.segment, styles[size], styles[variant], {
        [styles.disabled as string]: isActuallyDisabled,
        [styles.selected as string]: isSelected && !isActuallyDisabled,
        [styles.unselected as string]: !isSelected && !isActuallyDisabled,
    });

    return (
        <button
            ref={ref}
            type='button'
            className={segmentClasses}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            disabled={isActuallyDisabled}
            aria-pressed={isSelected}
            aria-label={label}
            data-value={value}
        >
            {icon && (
                <span className={styles.icon}>
                    {createIconElement(icon, { className: styles.iconSvg, removeFill: false })}
                </span>
            )}
            <span className={styles.label}>{label}</span>
        </button>
    );
};

StanSegment.displayName = 'StanSegment';
